import {
  Box,
  CircularProgress,
  Grid,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { dashboardItemsSelector } from '../../redux/dashboard';

// Helper function to calculate % growth
const calculateGrowth = (data) => {
  if (!data || data.length < 2) return 0;

  const current = data[data.length - 1].current;
  const previous = data[data.length - 2].current;

  if (previous === 0 || previous > current) return 0; // Avoid division by zero
  return (((current - previous) / previous) * 100).toFixed(2);
};

const OrderData = () => {
  const defaultChartData = useSelector(dashboardItemsSelector);
  const chartData = defaultChartData?.chartData?.orderDataAnalytics?.data;
  const isLoading =
    defaultChartData?.chartData?.orderStatusAnalytics?.isLoading;
  const [viewType, setViewType] = useState('week');

  const handleChange = (event) => {
    setViewType(event.target.value);
  };

  const currentData = chartData[viewType];
  const growth = calculateGrowth(currentData);
  const dataKey =
    viewType === 'week' ? 'day' : viewType === 'month' ? 'week' : 'month';

  return (
    <Box title="Order Growth" style={{ flexGrow: 1, width: '100%' }}>
      <Typography variant="h3" className="mediumFont" style={{ marginTop: 20 }}>
        {'Order Data'}
      </Typography>
      <Grid
        container
        spacing={2}
        style={{
          marginLeft: 30,
          marginTop: 10,
          marginRight: 30,
          alignItems: 'center',
          height: 90,
        }}
      >
        <Grid size={{ xs: 6, md: 8 }} style={{ flexGrow: 1 }}>
          <Select
            value={viewType}
            onChange={handleChange}
            style={{ width: 120, height: 30 }}
          >
            <MenuItem value="week">Daily</MenuItem>
            <MenuItem value="month">Weekly</MenuItem>
            <MenuItem value="year">Monthly</MenuItem>
          </Select>
        </Grid>
        <Grid size={0} style={{ marginRight: 50 }}>
          <Typography
            variant="h6"
            className="mediumFont"
            style={{ color: '#7a7979' }}
          >
            {`Growth from last ${dataKey}`}
          </Typography>
          <Typography
            variant="h2"
            className="mediumFont"
            style={{ color: growth >= 0 ? '#3f8600' : '#cf1322', marginTop: 5 }}
          >
            {`${growth}%`}
          </Typography>
        </Grid>
      </Grid>

      <ResponsiveContainer width={'100%'} height={300}>
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress size={30} />
          </div>
        ) : (
          <LineChart margin={{ right: 20 }} data={currentData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey={'name'}
              style={{
                fontSize: viewType === 'year' ? '8px' : '10px',
              }}
              minTickGap={2}
              interval={0}
              padding={{ right: 20 }}
            />
            <YAxis />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="current"
              stroke="#8884d8"
              strokeWidth={3}
            />
          </LineChart>
        )}
      </ResponsiveContainer>
    </Box>
  );
};

export default OrderData;
